<template>
  <svg v-bind="$attrs">
    <slot></slot>
  </svg>
</template>

<script setup lang="ts">

</script>

<style scoped>
.svg-icon {
  width: 1.8em;
  height: 1.8em;
  fill: currentColor; 
  vertical-align: middle;
}
</style>